import { getNoImg } from "@/utils/media";

export default {
  data() {
    return {
      imgHasError: {},
    };
  },
  methods: {
    /**
     * Définit le catalogue de l'offre.
     * @param {Object} ligne Infos de la lignes.
     * @returns {Object} Produit de la ligne.
     */
    catalogue(ligne) {
      if (this.defineOffer(ligne)?.manuel_numerique) {
        return "numerique";
      }
      if (this.defineOffer(ligne)?.fourniture) {
        return "fourniture";
      }
      if (this.defineOffer(ligne)?.article) {
        return "papier";
      }
      return "autre";
    },
    /**
     * Définit le produit selon son catalogue.
     * @param {Object} ligne Infos de la lignes.
     * @returns {Object} Produit de la ligne.
     */
    defineProduct(ligne) {
      if (ligne.etat_code !== undefined) {
        // Etiquette
        return ligne.article;
      }

      return ligne?.offre?.manuel_numerique
        || ligne?.offre?.fourniture
        || ligne?.offre?.article
        || ligne?.offre;
    },
    /**
     * Définit l'offre selon son catalogue.
     * @param {Object} ligne Infos de la ligne.
     * @returns {Object} Offre de la ligne.
     */
    defineOffer(ligne) {
      return ligne.offre || this.defineProduct(ligne).offre;
    },
    /**
     * Définit l'image d'une ligne.
     * @param {Object} ligne Infos de la ligne.
     * @returns {String} URL de l'image.
     */
    defineImgUrl(ligne) {
      const product = this.defineProduct(ligne);
      let type = "image";
      // TODO: revoir quand on aura les livres papiers et les fournitures
      if (product.offre_defaut?.manuel_numerique) {
        type = "numerique";
      } else if (product.offre_defaut?.article) {
        type = "papier";
      } else if (product.offre_defaut?.fourniture) {
        type = "fourniture";
      }

      if (ligne.etat_code !== undefined) {
        // Etiquette
        return ligne.article.url_couverture;
      }

      if (this.imgHasError[ligne.id] || this.catalogue(ligne) === "autre") {
        return getNoImg(type);
      }

      if (this.catalogue(ligne) === "fourniture") {
        return `https://depot.lde.fr/cdn/interdacta/${this.defineProduct(ligne).reference_interdacta}.jpg`;
      }

      return this.defineProduct(ligne).url_couverture;
    },
  },
};
